import React from 'react'
import useShortCourses from './ShortCourseProvider'
import { BrainIcon, PuzzleIcon, AylaIcon, ClockIcon } from './icons'
import useTranslation from '../shared/TranslationProvider'
import { cn } from '../../lib/utils'

const pluralize = (count, singular, plural) => {
  return count > 1 ? plural : singular
}

const CourseOverview = () => {
  const { slug } = useShortCourses()
  const { t } = useTranslation(`${slug}.overview`)
  const sections = t('sections')

  return (
    <div className="-top-20 flex w-full justify-center md:absolute md:mb-8">
      <div
        className={cn(
          `flex flex-col border-[#e5e5e5] bg-white p-4 text-xl max-sm:text-sm md:flex-row md:divide-x md:divide-[#e5e5e5] md:rounded-xl md:border`,
        )}
      >
        {sections.map((section, idx) => (
          <Section
            key={`section-${idx}`}
            className="flex-1 text-center"
            section={section}
          />
        ))}
      </div>
    </div>
  )
}

export default CourseOverview

const Section = ({ section }) => {
  const { title, amount, singular, plural } = section
  const noun = pluralize(amount, singular, plural)
  const icons = {
    time: <ClockIcon />,
    exercises: <BrainIcon />,
    quizzes: <PuzzleIcon />,
    ayla: <AylaIcon />,
  }
  return (
    <div className="flex items-center justify-center text-intoo-blue-medium">
      <div className="mx-4">{icons[title]}</div>
      <div className="mr-4">
        {amount} {noun}
      </div>
    </div>
  )
}
